// TODO: remove this file when all content use contentFooter compoent instead

import { resolveServiceUrl } from "../../../react4xp/shared/Pdf/resolveServiceUrl";
import { requestPdf } from "./requestPdf";

window.loadingStatus = false

function b64toBlob(b64Data, contentType) {
  const sliceSize = 512;
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, {type: contentType});
}

function aria_exportPdf(event, serviceUrl, title, url) {
  if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
    event.preventDefault()
    exportPdf(serviceUrl, title, url)
  }
}

/**
 * Builds the default PDF service URL for the current site or preview context.
 *
 * @returns {string|null} The default PDF endpoint, or null when the app name cannot be derived.
 */
function getDefaultPdfServiceUrl() {
  const pathname = window.location && window.location.pathname ? window.location.pathname : ''
  const pathParts = pathname.split('/').filter(Boolean)
  let appName = null

  if (pathParts[0] === 'admin' && pathParts[1] === 'site' && pathParts[2] === 'preview' && pathParts[3]) {
    appName = pathParts[3]
  } else if (pathParts[0] === 'site' && pathParts[1]) {
    appName = pathParts[1]
  }

  if (!appName) {
    return null
  }

  return resolveServiceUrl(`_/service/${appName}/getPdf`, window?.location?.pathname || '')
}

/**
 * Normalizes a URL-like value by converting it to a string, trimming whitespace,
 * and rejecting empty or placeholder values.
 *
 * @param {*} rawValue - Value to normalize.
 * @returns {string|null} The normalized URL string, or null when the value is empty/invalid.
 */
function normalizeUrlValue(rawValue) {
  if (rawValue === undefined || rawValue === null) {
    return null
  }

  if (typeof rawValue !== 'string') {
    rawValue = String(rawValue)
  }

  const trimmedValue = rawValue.trim()
  if (!trimmedValue || trimmedValue === 'undefined' || trimmedValue === 'null') {
    return null
  }

  return trimmedValue
}

/**
 * Parses a JSON string containing extra PDF metadata values.
 *
 * @param {string|null|undefined} rawValues - Serialized JSON payload from the page.
 * @returns {object|null} Parsed object when valid JSON is supplied, otherwise null.
 */
function parsePdfValues(rawValues) {
  if (!rawValues || typeof rawValues !== 'string') {
    return null
  }

  try {
    const parsedValues = JSON.parse(rawValues)
    if (parsedValues && typeof parsedValues === 'object') {
      return parsedValues
    }
  } catch (e) {
    console.log('Invalid data-pdfvalues JSON', e)
  }

  return null
}

/**
 * Builds the JSON payload sent to the PDF service.
 *
 * @param {string|null|undefined} goalTitle - Page title to include as the goalTitle value.
 * @param {object|undefined} additionalValues - Extra fields to merge into the request body.
 * @returns {string|undefined} Serialized JSON string when at least one value exists, otherwise undefined.
 */
function buildPdfValues(goalTitle, additionalValues) {
  const values = {}

  if (goalTitle) {
    values.goalTitle = goalTitle
  }

  if (additionalValues && typeof additionalValues === 'object') {
    Object.assign(values, additionalValues)
  }

  return Object.keys(values).length > 0 ? JSON.stringify(values) : undefined
}

/**
 * Downloads the generated PDF returned by the PDF service.
 *
 * @param {object} data - Service response payload.
 * @param {string} title - Title used as the downloaded file name.
 * @returns {boolean} True when a PDF was present and the download was started.
 */
function downloadPdfResponse(data, title) {
  // The service answers 200 with an empty payload when generation failed, so an absent
  // base64 body must be treated as a failure rather than a silent no-op.
  if (!data || !data.content || !data.content.content) {
    return false
  }

  const fileName = title + '.pdf';
  const blob = b64toBlob(data.content.content, 'application/pdf');
  if (window.navigator.msSaveBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    window.navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
    a.download = fileName
    document.body.appendChild(a)
    a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
    document.body.removeChild(a)
  }

  return true
}

/**
 * Reports a failed PDF export attempt.
 *
 * @param {string} reason - Short machine-readable failure reason.
 * @param {*} [detail] - Optional additional error detail for the console.
 */
function reportPdfExportFailure(reason, detail) {
  console.warn('PDF export failed', reason, detail)
}

function requestPdfDownload(serviceUrl, title, url, values) {
  if (window.loadingStatus) return
  window.loadingStatus = true
  requestPdf(serviceUrl, url, values)
    .then((data) => {
      if (!downloadPdfResponse(data, title)) throw new Error('PDF response was empty')
    })
    .catch((error) => reportPdfExportFailure('request-failed', error))
    .finally(() => {
      window.loadingStatus = false
    })
}

function createHeadingOverview() {
  const layout = $('.b-headings-overview').data('layout')
  const h2Headers = $('h2', '.tekst-content')
  if (layout === 'steg-veileder-kapittel') {
    const iconUrl = $('.icon-info').data('icon-url')
    if (!$('.b-headings-overview__link').length) {
      if (h2Headers.length > 0) {
        $('.b-headings-overview').show()

        $(h2Headers).each(function () {
          const label = $(this).text()
          const customId = label.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '-').toLowerCase()
          const item = `
            <li>
              <a class="b-headings-overview__link" href="#${customId}">
                <img class="b-headings-overview__arrowIcon" src="${iconUrl}" alt="" role="presentation" aria-hidden="true"/>
                ${label}
              </a>
            </li>
          `;

          $(this).attr('id', customId)
          $('.b-headings-overview__list').append(item)
        })
      }
    }
  } else if ($('.b-headings-overview__link').length) {
    if (h2Headers.length > 0) {
      $(h2Headers).each(function () {
        const label = $(this).text();
        const customId = label.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '-').toLowerCase();
        $(this).attr('id', customId)
      })
    }
  }
}

$(document).ready(function () {
  if ($('.b-headings-overview').length) { createHeadingOverview() }

  $('#exportPdf, #exportTilskuddRegulationsPdf').click(function (event) {
   event.preventDefault()
    const serviceUrlRaw = normalizeUrlValue($(this).data('getpdfservice'))
    const pageUrlRaw = normalizeUrlValue($(this).data('pageurl'))
    const pathname = window.location && window.location.pathname ? window.location.pathname : ''
    const serviceUrl = resolveServiceUrl(serviceUrlRaw && encodeURI(serviceUrlRaw), pathname) || getDefaultPdfServiceUrl()
    const url = pageUrlRaw && encodeURI(pageUrlRaw)
    const title = $(this).data('title')
    const goalTitles = $('#goalTitle')[0] || undefined
    // #goalTitle only exists on goal pages; every other layout must fall back to the button's
    // data-title so the PDF metadata title (sent as 'tittel') is never left empty.
    const goalTitle = (goalTitles && goalTitles.textContent) || title
    const additionalPdfValues = parsePdfValues($(this).attr('data-pdfvalues')) || {}

    if (!serviceUrl || !url) {
      console.warn('PDF export aborted due to missing URL data attributes', {
        hasServiceUrl: !!serviceUrl,
        hasPageUrl: !!url
      })
      return
    }

    requestPdfDownload(serviceUrl, title, url, buildPdfValues(goalTitle, additionalPdfValues))
  })

  if ($('#article').length) {
    $('#skip-to-article-content').attr('href', '#article')
  }

  const duplicatedIds = getDuplicatedIds()
  if (duplicatedIds.length) {
    for (const id of duplicatedIds) {
      $('*').filter('#' + id).each(function () {
        $(this).attr('id', id + '-' + randomId() + randomId() + '-' + randomId())
      })
    }
  }

  // Removes all empty bullet lists
  $('ul').each(function () {
    if ($(this).has('li').length === 0) { $(this).remove() }
  })
})

function randomId() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
}

function exportPdf(serviceUrl, title, url) {
  const normalizedServiceUrl = normalizeUrlValue(serviceUrl)
  const pathname = window.location && window.location.pathname ? window.location.pathname : ''
  const resolvedServiceUrl = resolveServiceUrl(normalizedServiceUrl, pathname) || getDefaultPdfServiceUrl()
  const normalizedPageUrl = normalizeUrlValue(url)
  if (!resolvedServiceUrl || !normalizedPageUrl) {
    console.warn('PDF export aborted due to invalid URL arguments', {
      hasServiceUrl: !!resolvedServiceUrl,
      hasPageUrl: !!normalizedPageUrl
    })
    return
  }
  requestPdfDownload(resolvedServiceUrl, title, normalizedPageUrl,
    buildPdfValues(Object.keys($('#goalTitle')).length != 0 ? $('#goalTitle')[0].textContent : title, null))
}

function downloadVersion(documasterUrl, id) {
  $.ajax({
    type: 'POST',
    url: documasterUrl,
    dataType: 'json',
    processData: true,
    data: {
      id: id
    },
    success: function (data) {
      const file = data.file
      const mimeType = data.mimeType
      const fileName = data.fileName
      const blob = b64toBlob(file, mimeType)
      if (window.navigator.msSaveBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob, { type: mimeType })
        a.download = fileName
        document.body.appendChild(a)
        a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
        document.body.removeChild(a)
      }
    },
    error: function (xhr, ajaxOptions, thrownError) {
      console.log('error')
    }
  })
}

// Accessibility
$(document).ready(function () {
  if ($('.b-table__wrapper').length) {
    $('.b-table__wrapper').each(function () {
      const tabindex = $(this).attr('tabindex')
      if (!(tabindex !== undefined && tabindex !== false)) {
        $(this).attr('tabindex', '0')
      }
    })
  }
})

// get all ids from current page
function fetchPageIds() {
  return $('*').map(function () {
    if (this.id) {
      return this.id
    }
  }).get()
}

function getDuplicatedIds() {
  const ids = fetchPageIds()
  const duplicatedIds = []

  if (ids.length) {
    const sortedIds = ids.sort()
    for (let i = 0; i < sortedIds.length - 1; i++) {
      if (sortedIds[i + 1] == sortedIds[i] && duplicatedIds.indexOf(sortedIds[i]) == -1) {
        duplicatedIds.push(sortedIds[i])
      }
    }
  } return duplicatedIds
}

/**
 * Ugly hack to ensure that the functions are included in project-bundle.js
 * in /build as tsup filters out unused functions
*/
window.file_namespace = {};
window.file_namespace.downloadVersion = downloadVersion;
